/** Primary phone — contact page and WhatsApp */
export const CONTACT_PHONE_E164 = '919963738822'

export const CONTACT_PHONE_DISPLAY = '+91 9963738822'

export const CONTACT_PHONE_HREF = `tel:+${CONTACT_PHONE_E164}`

export const CONTACT_EMAIL = 'admin@zene.ai'

export const CONTACT_EMAIL_HREF = `mailto:${CONTACT_EMAIL}`

export const WHATSAPP_PHONE_E164 = CONTACT_PHONE_E164

export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_PHONE_E164}`

export const WHATSAPP_DISPLAY = CONTACT_PHONE_DISPLAY

export const CONTACT_PAGE_PATH = '/contact'

export const CONTACT_ADDRESS =
  'Zene Edtech Pvt Ltd, #990, Road Number 50, Ayyappa Society, Khanamet, Madhapur, Hyderabad, Telangana, India, 500081.'

export const CONTACT_ADDRESS_HREF =
  'https://www.google.com/maps/dir/17.386243,78.5628855/Zene+Solutions+%E2%80%93+Microsoft+Dynamics+CRM+%26+PowerApps+Training+in+Hyderabad,+A2+Square,+Jai+Hind+Gandhi+Rd,+VIP+Hills,+Jaihind+Enclave,+Madhapur,+Hyderabad,+Telangana+500081/@17.4281241,78.399783,27026m/data=!3m2!1e3!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3bcb91cf04aca173:0x7f80f63a198c3aed!2m2!1d78.3874049!2d17.4512265?entry=ttu&g_ep=EgoyMDI2MDYyOC4wIKXMDSoASAFQAw%3D%3D'
